import { getCookie } from "./cookies";

let colors = ['red', 'yellow', 'green', 'blue', 'purple', 'orange', 'tomato', 'papaya', 'gold', 'cyan', 'darkblue', 'darkgreen', 'darkmagenta', 'darkorchid', 'darkred', 'darkgoldenrod', 'aliceblue', 'maroon', 'rebeccapurple'];

const display_loader = (bM) => {
    let lines = document.getElementsByClassName('inner');
    let loader = document.getElementById('loader');
    let barrier = document.getElementById('barrier');
    let el = document.getElementById('yoyoyo');
    loader.style.display = "none";
    barrier.style.display = "none";
    el.style.display = "none";
    if (true || getCookie('mel-mode') === "true") {
        el.style.display = "flex";
    } else if (getCookie("bruce-mode") === "true") {
        Array.from(lines).forEach(e => {
            e.style.borderColor = 'gray';
        })

        let loader = document.getElementById('loader');
        let barrier = document.getElementById('barrier');
        loader.style.display = "block";
        barrier.style.display = "block";
    } else {
        Array.from(lines).forEach(e => {
            // console.log("hello")
            e.style.borderColor = colors[Math.floor(colors.length * Math.random()) + 1];
        })
        loader.style.display = "block";
        barrier.style.display = "block";
    }
}

const close_loader = () => {
    let loader = document.getElementById('loader');
    let barrier = document.getElementById('barrier');
    let el = document.getElementById('yoyoyo');
    loader.style.display = "none";
    barrier.style.display = "none";
    el.style.display = "none"
}



export {
    display_loader,
    close_loader
}

